import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaCheck, FaCopy, FaPaperPlane } from "react-icons/fa";

const FORM_ENDPOINT = "https://getform.io/f/pamqyrxa";

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const email = "aakashanand560@gmail.com";

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      window.location.href = `mailto:${email}`;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    setStatus("sending");

    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });

      if (response.ok) {
        setStatus("sent");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section name="Contact" className="aurora-section px-6 py-20">
      <div className="mx-auto grid max-w-5xl grid-cols-1 items-start gap-12 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-3xl font-bold text-slate-900 dark:text-white md:text-4xl">
            Let's <span className="accent-text">Work Together</span>
          </h2>

          <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-600 dark:text-zinc-400">
            Have an idea, opportunity, or just want to say hi? I'd love to
            hear from you — fill out the form and I'll get back to you
            within 24 hours.
          </p>

          <button
            type="button"
            onClick={copyEmail}
            className="btn-secondary mt-8"
          >
            {copied ? <FaCheck className="text-emerald-500" /> : <FaCopy className="text-indigo-500" />}
            {copied ? "Email copied" : email}
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="panel p-6 sm:p-8"
        >
          <AnimatePresence mode="wait">
            {status === "sent" ? (
              <motion.div
                key="sent"
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex flex-col items-center justify-center gap-3 py-10 text-center"
              >
                <span className="grid h-12 w-12 place-items-center rounded-full bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400">
                  <FaCheck size={18} />
                </span>
                <p className="text-base font-semibold text-slate-900 dark:text-white">
                  Message sent — thank you!
                </p>
                <p className="max-w-xs text-sm text-slate-500 dark:text-zinc-400">
                  I've received it and will get back to you within 24 hours.
                </p>
                <button
                  type="button"
                  onClick={() => setStatus("idle")}
                  className="btn-secondary mt-2"
                >
                  Send another message
                </button>
              </motion.div>
            ) : (
              <motion.form
                key="form"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                onSubmit={handleSubmit}
              >
                <div className="mb-5">
                  <label className="mb-1.5 block text-sm font-medium text-slate-600 dark:text-zinc-400">
                    Your name
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20 dark:border-zinc-700 dark:bg-zinc-900 dark:text-white"
                  />
                </div>

                <div className="mb-5">
                  <label className="mb-1.5 block text-sm font-medium text-slate-600 dark:text-zinc-400">
                    Your email
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20 dark:border-zinc-700 dark:bg-zinc-900 dark:text-white"
                  />
                </div>

                <div className="mb-6">
                  <label className="mb-1.5 block text-sm font-medium text-slate-600 dark:text-zinc-400">
                    Message
                  </label>
                  <textarea
                    name="message"
                    rows="5"
                    required
                    className="w-full resize-none rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20 dark:border-zinc-700 dark:bg-zinc-900 dark:text-white"
                  />
                </div>

                {status === "error" && (
                  <p className="mb-4 rounded-lg bg-rose-50 px-4 py-2.5 text-sm font-medium text-rose-600 dark:bg-rose-500/10 dark:text-rose-400">
                    Something went wrong — please try again, or email me directly.
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === "sending"}
                  className="btn-primary w-full disabled:cursor-not-allowed disabled:opacity-60"
                >
                  <FaPaperPlane />
                  {status === "sending" ? "Sending..." : "Send Message"}
                </button>
              </motion.form>
            )}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
